import React from 'react';
import { Field, View, Input } from '@components';
import styled from 'styled-components';

const FieldComando = styled(Field)`
  margin-left: 0;
`;

const Fields = styled(View)`
  padding-right: 15px;
`;

export default function SQLConector() {
  return (
    <Fields>
      <FieldComando label="Comando" name="comando" rules={[{ required: true, message: 'Informe o comando' }]}>
        <Input.TextArea rows={10} />
      </FieldComando>
    </Fields>
  );
}
